export enum ErrorCode {
  INTERNAL_ERROR = "INTERNAL_ERROR",
  ENTITY_EXISTS = "ENTITY_EXISTS",
  NOT_FOUND = "NOT_FOUND",
  VALIDATION_ERROR = "VALIDATION_ERROR",
  STRIPE_ERROR = "STRIPE_ERROR",
}
